<template>
  <v-container fluid class="pa-0">
    <div class="layout-wrapper">
      <slot name="navbar.vertical"></slot>
      <slot name="navbar"></slot>
      <div id="layout_default_content" class="flex-fill">
        <div class="home">
          <slot></slot>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>

export default {
  name: 'LayoutDefault'
}
</script>

<style scoped>

</style>
